import { MilestoneType } from '../enums';
import { milestoneMessages } from '../milestoneMessages';

import { MilestoneDefinition } from './types';

const milestoneDefinition = (milestoneType: MilestoneType): MilestoneDefinition => {
    switch (milestoneType) {
        case MilestoneType.goalieGamesPlayed:
            return {
                column: 'gamesPlayed',
                header: milestoneMessages.labels.games_played,
                isGoalie: true,
                linkText: milestoneMessages.linkLabels.games_played,
                linkUrl: '/goalies?reportType=allTime&gameType=2&filter=gamesPlayed,gte,1&sort=gamesPlayed',
                sorted: [
                    {
                        id: 'gamesPlayed',
                        desc: true,
                    },
                ],
            };
        case MilestoneType.goalieWins:
            return {
                column: 'wins',
                header: milestoneMessages.labels.wins,
                isGoalie: true,
                linkText: milestoneMessages.linkLabels.wins,
                linkUrl: '/goalies?reportType=allTime&gameType=2&filter=gamesPlayed,gte,1&sort=wins',
                sorted: [
                    {
                        id: 'wins',
                        desc: true,
                    },
                ],
            };
        case MilestoneType.goalieShutouts:
            return {
                column: 'so',
                header: milestoneMessages.labels.shutouts,
                isGoalie: true,
                linkText: milestoneMessages.linkLabels.shutouts,
                linkUrl: '/goalies?reportType=allTime&gameType=2&filter=gamesPlayed,gte,1&sort=shutouts',
                sorted: [
                    {
                        id: 'so',
                        desc: true,
                    },
                ],
            };
        case MilestoneType.goalieMinutesPlayed:
            return {
                column: 'toiMinutes',
                header: milestoneMessages.labels.minutes,
                isGoalie: true,
                linkText: milestoneMessages.linkLabels.minutes,
                linkUrl: '/goalies?reportType=allTime&gameType=2&filter=gamesPlayed,gte,1&sort=timeOnIce',
                sorted: [
                    {
                        id: 'toiMinutes',
                        desc: true,
                    },
                ],
            };
        case MilestoneType.skaterGamesPlayed:
            return {
                column: 'gamesPlayed',
                header: milestoneMessages.labels.games_played,
                isGoalie: false,
                linkText: milestoneMessages.linkLabels.games_played,
                linkUrl: '/skaters?reportType=allTime&gameType=2&filter=gamesPlayed,gte,1&sort=gamesPlayed',
                sorted: [
                    {
                        id: 'gamesPlayed',
                        desc: true,
                    },
                ],
            };
        case MilestoneType.skaterGoals:
            return {
                column: 'goals',
                header: milestoneMessages.labels.goals,
                isGoalie: false,
                linkText: milestoneMessages.linkLabels.goals,
                linkUrl: '/skaters?reportType=allTime&gameType=2&filter=gamesPlayed,gte,1&sort=goals',
                sorted: [
                    {
                        id: 'goals',
                        desc: true,
                    },
                ],
            };
        case MilestoneType.skaterAssists:
            return {
                column: 'assists',
                header: milestoneMessages.labels.assists,
                isGoalie: false,
                linkText: milestoneMessages.linkLabels.assists,
                linkUrl: '/skaters?reportType=allTime&gameType=2&filter=gamesPlayed,gte,1&sort=assists',
                sorted: [
                    {
                        id: 'assists',
                        desc: true,
                    },
                ],
            };
        case MilestoneType.skaterPoints:
        default:
            return {
                column: 'points',
                header: milestoneMessages.labels.points,
                isGoalie: false,
                linkText: milestoneMessages.linkLabels.points,
                linkUrl: '/skaters?reportType=allTime&gameType=2&filter=gamesPlayed,gte,1&sort=points',
                sorted: [
                    {
                        id: 'points',
                        desc: true,
                    },
                ],
            };
    }
};

export default milestoneDefinition;
